const BaseAvantRouter = require('angular/avantRouter.js')

class AwesomeAvantRouter extends BaseAvantRouter{
  constructor($httpProvider, $stateProvider, $sceDelegateProvider, $urlMatcherFactoryProvider){
    super(...arguments)
    delete this.states.customer_application.templateUrl
    Object.assign(this.states.customer_application, {
      template: function($stateParams){
        return `<customer-applications-${$stateParams.stage.replace('_', '-')}-stage />`
      }
    })
  }
}

AwesomeAvantRouter.$inject = [
  "$httpProvider",
  "$stateProvider",
  "$sceDelegateProvider",
  "$urlMatcherFactoryProvider",
];

angular
.module("avant.customer_applications.factories")
.provider("avantRouter", AwesomeAvantRouter)

module.exports = AwesomeAvantRouter
